export default __webpack_public_path__ + "08fa6c9cbda3ca34de23e944f6fb6616.png";